(() => {
  const labels = window.sashaVariantLabels;
  if (!labels) return;

  const replacements = [
    ['Classic Semi-Glossy Paper Metal Framed Poster', labels.framed],
    ['Classic Semi-Glossy Paper Poster', labels.unframed],
  ];

  const replaceTextNode = (textNode) => {
    let value = textNode.nodeValue;
    for (const [source, replacement] of replacements) {
      if (value.includes(source)) value = value.split(source).join(replacement);
    }
    if (value !== textNode.nodeValue) textNode.nodeValue = value;
  };

  const replaceText = (root) => {
    if (root.nodeType === Node.TEXT_NODE) {
      replaceTextNode(root);
      return;
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) replaceTextNode(node);
  };

  const run = () => replaceText(document.body);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'characterData') {
        replaceTextNode(mutation.target);
        continue;
      }

      for (const node of mutation.addedNodes) {
        replaceText(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
